import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["pipedriveTriggerGoal"]; 

  connect() {
    this.togglePipedriveTriggerGoal();
  }

  logSelection(event) {
    const selectedValue = event.target.dataset.value;
    this.togglePipedriveTriggerGoal(selectedValue);
  }

  togglePipedriveTriggerGoal(selectedValue = null) {
    if (!selectedValue) {
      const selectedRadio = document.querySelector('input[name="team[trigger]"]:checked');
      selectedValue = selectedRadio ? selectedRadio.dataset.value : "";
    }

    if (selectedValue === "Pipedrive") {
      this.pipedriveTriggerGoalTarget.style.display = "block";
    } else {
      this.pipedriveTriggerGoalTarget.style.display = "none";
    }
  }
}
